import { render } from "./PatientInfoTab.vue?vue&type=template&id=2ecbc7e1&scoped=true"
import script from "./PatientInfoTab.vue?vue&type=script&lang=js"
export * from "./PatientInfoTab.vue?vue&type=script&lang=js"

import "./PatientInfoTab.vue?vue&type=style&index=0&id=2ecbc7e1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecbc7e1"]])

export default __exports__